import { Outlet } from "react-router-dom";
import { PageMeta } from "./PageMeta";

export type Props = {
  title: string;
};

/**
 * A page with nothing around it.
 *
 * The intake pages are designed as two full-height panels carrying their own
 * logo, so the site header, navigation and footer would be a third thing
 * competing with them. Someone who arrives here followed a link to do one
 * thing.
 */
export const IntakeLayout = ({ title }: Props) => (
  <>
    <PageMeta title={title} />
    <Outlet />
  </>
);

export default IntakeLayout;
